(() => {
  const containerSelector = '[data-collection-filter-align]';
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const observers = new WeakMap();
  const scheduled = new WeakSet();

  const getPageTop = (element) => element.getBoundingClientRect().top + window.scrollY;

  const getAlignmentTargetTop = () => {
    const circleMedia = document.querySelector(
      '.section-quick-collection-circles .quick-collection-circles__media'
    );

    if (circleMedia) return getPageTop(circleMedia);

    const quickSection = document.querySelector('.section-quick-collection-circles .quick-collection-circles__inner');
    const quickSectionHasContent = quickSection?.querySelector(
      '.quick-collection-circles__nav, .quick-collection-circles__heading-wrapper'
    );
    if (quickSectionHasContent) return getPageTop(quickSection);

    const collectionHero = document.querySelector('.collection-hero__title, .collection-hero__text-wrapper, .collection-hero__inner');
    if (collectionHero) return getPageTop(collectionHero) + 24;

    const breadcrumbs = document.querySelector('.section-breadcrumbs');
    if (!breadcrumbs) return null;

    const rect = breadcrumbs.getBoundingClientRect();
    return rect.bottom + window.scrollY;
  };

  const alignContainer = (container) => {
    const facets = container.querySelector('.facets-wrapper');
    if (!facets) return;

    if (!desktopQuery.matches) {
      facets.style.removeProperty('--collection-sidebar-dynamic-margin');
      return;
    }

    const targetTop = getAlignmentTargetTop();
    if (targetTop === null) {
      facets.style.removeProperty('--collection-sidebar-dynamic-margin');
      return;
    }

    facets.style.setProperty('--collection-sidebar-dynamic-margin', '0px');

    const adjustment = Number.parseFloat(container.dataset.filterAlignOffset || '0') || 0;
    const naturalTop = getPageTop(facets);
    const dynamicMargin = Math.round(targetTop + adjustment - naturalTop);

    facets.style.setProperty('--collection-sidebar-dynamic-margin', `${dynamicMargin}px`);
  };

  const scheduleAlign = (container) => {
    if (scheduled.has(container)) return;

    scheduled.add(container);
    window.requestAnimationFrame(() => {
      scheduled.delete(container);
      alignContainer(container);
    });
  };

  const setupContainer = (container) => {
    if (!container || observers.has(container)) return;

    observers.set(
      container,
      new MutationObserver(() => {
        scheduleAlign(container);
      })
    );

    observers.get(container).observe(container, { childList: true, subtree: true });
    scheduleAlign(container);
  };

  const setup = () => {
    document.querySelectorAll(containerSelector).forEach(setupContainer);
  };

  document.addEventListener('DOMContentLoaded', setup);
  window.addEventListener('load', setup);
  window.addEventListener('resize', () => {
    document.querySelectorAll(containerSelector).forEach(scheduleAlign);
  });
  document.addEventListener('shopify:section:load', setup);

  if (document.readyState !== 'loading') setup();
})();
